import { render } from "./Website.vue?vue&type=template&id=6a27ab5d&scoped=true"
import script from "./Website.vue?vue&type=script&lang=js"
export * from "./Website.vue?vue&type=script&lang=js"

import "./Website.vue?vue&type=style&index=0&id=6a27ab5d&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/xxiwant/lovestory/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a27ab5d"]])

export default __exports__